import { ShoppingCart, Plus } from 'lucide-react'

type Props = {
  isOpen:        boolean
  itemName:      string
  hasActiveList: boolean      // true → "add to list", false → "start a list"
  saving:        boolean
  onClose:       () => void
  onConfirm:     () => Promise<void> | void
}

export function OutOfStockSheet({
  isOpen, itemName, hasActiveList, saving, onClose, onConfirm,
}: Props) {
  if (!isOpen) return null

  const cta      = hasActiveList ? 'Add to list' : 'Start a list'
  const question = hasActiveList
    ? `You ran out of ${itemName}. Add it to your active shopping list?`
    : `You ran out of ${itemName}. Start a new shopping list with it?`

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
        onClick={onClose}
        aria-hidden
      />
      <div className="relative w-full max-w-[480px] rounded-t-[24px] bg-cream pb-8">
        <div className="flex justify-center pt-3 pb-2">
          <div className="h-1 w-10 rounded-full bg-border-avatar" />
        </div>

        <div className="px-5 pb-2">
          <div className="text-[10px] uppercase tracking-[0.18em] font-medium text-terracotta mb-1">
            Out of stock
          </div>
          <h2 className="font-serif text-[22px] font-normal leading-[1.15] tracking-[-0.015em] text-ink">
            <em className="italic">{itemName}</em> is empty.
          </h2>
          <p className="font-serif text-[14px] italic text-ink-muted mt-2 leading-[1.45]">
            {question}
          </p>
        </div>

        <div className="px-5 mt-6 flex flex-col gap-2">
          <button
            type="button"
            onClick={onConfirm}
            disabled={saving}
            className="w-full flex items-center justify-center gap-2 rounded-[14px] bg-forest text-forest-ink py-3 text-[14px] font-bold tracking-[-0.01em] disabled:opacity-50 transition"
          >
            {hasActiveList
              ? <Plus         className="h-4 w-4" strokeWidth={2} />
              : <ShoppingCart className="h-4 w-4" strokeWidth={2} />}
            {saving ? 'Adding…' : cta}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="w-full py-2 font-serif text-[13px] italic text-ink-muted"
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  )
}
